import { useQuery } from "@tanstack/react-query";
import { getWorkforceTypeHours } from "../actions/getWorkforceTypeHours.action";
import { ETimePeriods } from "../enums/timesheets.enum";


export const useGetWorkforceTypeHours = (period: ETimePeriods) => {
    return useQuery({
        queryKey: ["workforce-type-hours", period],
        queryFn: () => getWorkforceTypeHours(period),
    });
}